import { Token } from '@magikswap/sdk'
import { baseTokens } from 'config/constants/tokens'
// import SwapWarningTokens from 'config/constants/swapWarningTokens'
import tokenlist from '../config/constants/tokenLists/memecity.json'
// const swapWarningTokens = Object.values(SwapWarningTokens)
const goodTokens = Object.values(baseTokens)
const goodTokensMeme = Object.values(tokenlist.tokens.map((token) => {
  return new Token(token.chainId, token.address, token.decimals, token.symbol, token.name)
}))

const shouldShowSwapWarning = (swapCurrency: Token) => {
  return swapCurrency.symbol !== "ETH" && !goodTokens.some((warningToken) => warningToken.equals(swapCurrency))  && !goodTokensMeme.some((warningToken) => warningToken.equals(swapCurrency))
}

export default shouldShowSwapWarning
